import type { ScreenModule } from "../../../app/screen-module";
import { TenantProjectsPage } from "../pages";

export default {
	id: "tenant-admin.projects",
	path: "/admin/projects",
	area: "tenant-admin",
	navGroup: "組織",
	label: "プロジェクト",
	roles: ["tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: TenantProjectsPage,
} satisfies ScreenModule;
